import React, { useLayoutEffect, useRef, useState } from 'react';
import debounce from 'lodash/debounce';

interface SixteenNineIframeProps {
  src: string;
  title?: string;
  id: string;
  containerClass: string;
  testId?: string;
  allowFullScreen?: boolean;
}

const SixteenNineIframe = ({
  src,
  title,
  id,
  containerClass,
  testId,
  allowFullScreen = true
}: SixteenNineIframeProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState<number>();

  useLayoutEffect(() => {
    const handleContainerHeight = debounce(() => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.clientWidth;

        setContainerHeight(containerWidth * (9 / 16));
      }
    }, 200);

    handleContainerHeight();
    window.addEventListener('resize', handleContainerHeight);

    return () => {
      window.removeEventListener('resize', handleContainerHeight);
    };
  }, []);

  return (
    <div
      className={containerClass}
      data-testid={testId}
      ref={containerRef}
      style={{
        height:
          typeof containerHeight === 'number' ? `${containerHeight}px` : 'auto'
      }}
    >
      <iframe
        id={id}
        title={title}
        src={src}
        width="100%"
        height="100%"
        allowFullScreen={allowFullScreen}
        frameBorder="0"
      />
    </div>
  );
};

export default SixteenNineIframe;
